import 'regenerator-runtime/runtime';
import 'core-js/fn/object/entries';
import * as video from './video'
import * as slider from './slider'
import * as autocomplete from './autocomplete'
import * as map from './map'
import * as form from './form'
import * as mortgage from './mortgage'
import * as property from './property'
import * as featured from './featured'
import Slideout from 'slideout';

video.initalize()
slider.initalize()
autocomplete.initalize()
map.initalize()
form.initalize()
mortgage.initalize()
property.initalize();
featured.initalize();

class Navigation {
  constructor() {
    this.slideout = new Slideout({
      panel: $('.page-container')[0],
      menu: $('.mobile-navigation')[0],
      padding: 128 * 2,
      tolerance: 75,
    });
    this.slideout.on('open', () => {
      $('.page-container').one('touchstart mousedown', () => {
        this.slideout.close();
      });
    });
    $('.toggle-button').on('click', this.slideout.toggle.bind(this.slideout));
  }

  switchToMobile() {
    this.slideout.enableTouch();
    $('.search-form').hide();
    $('.search-form button.btn').show();
  }

  switchToDesktop() {
    this.slideout.close();
    this.slideout.disableTouch();
    $('.search-form').show();
    $('.search-form button.btn').hide();
  }
}

class ResizeWidthOnce {
  constructor(size, onBelow, onAbove, selector = null) {
    this.size = size;
    this.onBelow = onBelow;
    this.onAbove = onAbove;
    this.below = false;
    this.enabled = selector ? $(selector).length > 0 : true;
  }

  updateWidth(width) {
    if (!this.enabled) return;
    if (width < this.size) {
      if (!this.below) {
        this.below = true;
        this.onBelow();
      }
    } else if (this.below) {
      this.below = false;
      this.onAbove();
    }
  }
}

function updateIframeWeight() {
  if ($('.find-schools').length) {
    let oldsrc = $('.find-schools').attr('src');
    let newsrc = oldsrc.replace(/width=[0-9]+/, 'width=' + $('.property-information').width());
    if (oldsrc !== newsrc) {
      $('.find-schools').attr('src', newsrc);
    }
  }
}

function updateCarouselHeight(height) {
  if ($('.carousel-fluid').length) {
    $('.carousel-fluid').height('auto');
    $('.carousel-fluid .aspect-ratio-9-5').css('padding-top', '55.55556%');
    let fullHeight = $('.carousel-fluid .plyr__video-wrapper').outerHeight();
    let carouselHeight = height - $('.navigation-fluid').height() - 100;
    carouselHeight = Math.max($('.carousel-fluid').height(), carouselHeight);
    carouselHeight = Math.min(fullHeight, carouselHeight);
    carouselHeight = Math.min(height * 0.70, carouselHeight);
    $('.carousel-fluid .plyr__video-wrapper').css('margin-top', -((fullHeight - carouselHeight) / 2));
    $('.carousel-fluid').height(carouselHeight).css('overflow', 'hidden');
    $('.carousel-fluid .aspect-ratio-9-5').css('padding-top', carouselHeight);
  }
}

const navigation = new Navigation();
const w768 = new ResizeWidthOnce(768, navigation.switchToMobile.bind(navigation), navigation.switchToDesktop.bind(navigation));
const w1199 = new ResizeWidthOnce(1999, () => {
  $('.search-preview').css('left', Math.max(16, $('.search-form-slideout').position().left - 850));
}, () => {
  $('.search-preview').hide();
}, '.search-form-slideout');

$(window).on('resize', () => {
  const width = $(window).width();
  const height = $(window).height();
  w768.updateWidth(width);
  w1199.updateWidth(width);
  updateCarouselHeight(height);
  updateIframeWeight();
});
$(window).trigger('resize');
